<template>
  <div>
    <template v-if="estimateState == 2">
      <div>
        <div class="flex mb-6">
          <div>
            <h2 class="text-2xl font-semibold text-gray-92 leading-8">
              見積もり
            </h2>
          </div>
          <div class="ml-auto flex space-x-4">
            <a
              v-if="estimate.estimate_file_url"
              class="flex rounded border p-3 leading-4 items-center"
              :href="estimate.estimate_file_url"
            >
              <div>
                <img src="@/assets/icons/FileDL.svg" />
              </div>
              <div class="pl-2 text-gray-92">ダウンロード(.xlsx)</div>
            </a>
          </div>
        </div>

        <section
          class="mb-20 p-8 bg-white rounded-lg"
          style="min-width: 666px; max-width: 986px"
        >
          <div class="flex justify-between">
            <div class="text-gray-92 text-xl">
              {{ patternNumber }}/{{ estimate.est_contents.length }}
              <span class="text-base">件</span>
            </div>
            <div v-if="estimate.est_contents.length > 1" class="flex">
              <router-link
                :to="{
                  name: 'TxEstimate',
                  params: { patternNumber: prevPatternNumber },
                }"
              >
                <img
                  class="cursor-pointer hover:button"
                  src="@/assets/icons/ArrowBack.svg"
                />
              </router-link>
              <router-link
                :to="{
                  name: 'TxEstimate',
                  params: { patternNumber: nextPatternNumber },
                }"
              >
                <img
                  class="cursor-pointer hover:button"
                  src="@/assets/icons/ArrowNext.svg"
                />
              </router-link>
            </div>
          </div>
          <div
            class="text-blue w-full py-3 text-center leading-4 mt-8 mb-12 font-semibold"
            style="background: rgba(108, 126, 206, 0.1)"
          >
            この内容で送信されました
          </div>
          <div class="flex justify-between">
            <div style="color: #344464">{{ estimate.buyer_company_name }}</div>
            <div class="font-semibold text-gray-92">
              No: {{ estimate.transaction_service_id }} - {{ patternNumber }}
            </div>
          </div>
          <div class="mb-2" style="color: #344464">
            {{ estimate.buyer_name }}様
          </div>
          <div class="text-xl leading-8 font-semibold text-gray-92">
            {{ estimate.service_category_name }}
          </div>
          <div
            v-if="estimate.est_contents[estIndex]"
            class="leading-8 pt-2"
            style="margin-bottom: 36px"
          >
            {{ estimate.est_contents[estIndex].title }}
            <div class="text-2xl font-semibold">
              {{ estimate.est_contents[estIndex].title }}
            </div>
            <div
              class="leading-4"
              style="font-size: 13px"
              v-if="estimate.est_contents[estIndex].type == 'auto'"
            >
              ※この見積もり書は自動で算出されました
            </div>
          </div>

          <div class="text-gray-92">下記の通りお見積り申し上げます。</div>

          <div class="flex justify-between items-end mb-12">
            <div>
              <div class="font-semibold text-gray-92">
                お見積り金額
                <span
                  v-if="estimate.est_contents[estIndex]"
                  class="ml-2 mr-1 text-2xl leading-6"
                  >{{
                    amountFormatter(
                      estimate.est_contents[estIndex].total_with_tax
                    )
                  }}</span
                >円（税込）
              </div>
            </div>
            <div class="text-right">
              <div class="text-gray-62">{{ estimate.publishedAt }}</div>
              <div class="text-gray-92 font-semibold">
                {{ estimate.seller_company_name }}
              </div>
              <div class="text-gray-92 font-semibold">
                {{ estimate.published_seller_name }}
              </div>
            </div>
          </div>

          <div class="leading-5 text-gray-62">
            <div
              class="grid grid-cols-12 gap-0 py-4 border-b border-gray-12 font-semibold"
              :class="{ is_sticky: onScroll }"
            >
              <div class="col-span-5 pl-4 pr-2 text-center">項目</div>
              <div class="col-span-7 grid grid-cols-11 gap-0">
                <div class="col-span-3 text-center">数量</div>
                <div class="col-span-3 px-2 text-center">単価（円）</div>
                <div class="col-span-2 px-2 text-center">期間</div>
                <div class="col-span-3 px-2 text-right pr-2">小計（税抜）</div>
              </div>
            </div>
            <section v-if="estimate.est_contents[estIndex]">
              <div
                v-for="item in estimate.est_contents[estIndex].section_items"
                :key="item.id"
              >
                <div v-if="item.amount">
                  <div
                    class="grid grid-cols-12 gap-0 h-12 items-center bg-slate-300 text-gray-92"
                  >
                    <div class="col-span-9 pl-4 font-semibold">
                      {{ item.name }}
                    </div>
                    <div
                      class="col-span-3 pr-4 text-right text-base font-semibold"
                    >
                      {{ amountFormatter(item.amount) }}
                    </div>
                  </div>
                  <div
                    v-for="detailItem in item.detail_items"
                    :key="detailItem.id"
                    class="grid grid-cols-12 gap-0 items-center h-16 border-b border-gray-12 text-gray-92"
                  >
                    <div class="col-span-5 pl-4 pr-5 text-gray-92">
                      {{ detailItem.name }}
                    </div>
                    <div class="col-span-7 grid grid-cols-11 gap-0">
                      <div
                        v-if="detailItem.quantity"
                        class="col-span-3 text-base text-center text-gray-92"
                      >
                        <span>{{ amountFormatter(detailItem.quantity) }}</span>
                        <span class="text-xs">{{
                          detailItem.quantity_unit_name
                        }}</span>
                      </div>
                      <span
                        v-else
                        class="col-span-3 flex justify-center text-xs"
                        >ー</span
                      >
                      <div
                        v-if="detailItem.price"
                        class="col-span-3 text-base text-right text-gray-92 pr-8"
                      >
                        {{ amountFormatter(detailItem.price) }}
                      </div>
                      <span
                        v-else
                        class="col-span-3 flex justify-center text-xs"
                        >ー</span
                      >
                      <div
                        v-if="detailItem.term"
                        class="col-span-2 flex justify-center items-baseline text-base text-gray-92"
                      >
                        {{ detailItem.term }}
                        <span class="text-xs">{{
                          detailItem.term_unit_name
                        }}</span>
                      </div>
                      <span
                        v-else
                        class="col-span-2 flex justify-center text-xs"
                        >ー</span
                      >
                      <div
                        v-if="detailItem.amount"
                        class="col-span-3 pr-4 text-right text-gray-92 text-base"
                      >
                        {{ amountFormatter(detailItem.amount) }}
                      </div>
                      <span
                        v-else
                        class="col-span-2 flex justify-center text-xs"
                        >ー</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.note"
                  class="grid grid-cols-12 gap-0 items-center"
                >
                  <div
                    class="col-span-12 text-xs text-gray-92 p-4 pb-8 whitespace-pre-wrap"
                  >
                    {{ item.note }}
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div
            v-if="estimate.est_contents[estIndex]"
            class="text-gray-92 ml-auto mt-20"
            style="width: 25rem"
          >
            <div class="flex leading-6 border-b border-gray-12 py-4 px-2">
              <div class="px-2 font-semibold">小計（税別）</div>
              <div class="ml-auto text-lg px-2" style="color: #344464">
                {{ amountFormatter(estimate.est_contents[estIndex].total) }}
                <span class="ml-1 text-xs">円</span>
              </div>
            </div>
            <div class="flex leading-6 border-b border-gray-12 py-4 px-2">
              <div class="px-2 font-semibold">消費税（10%)</div>
              <div class="ml-auto text-lg px-2" style="color: #344464">
                {{ amountFormatter(estimate.est_contents[estIndex].tax) }}
                <span class="ml-1 text-xs">円</span>
              </div>
            </div>
            <div class="flex leading-10 py-4 px-2">
              <div class="px-2 font-semibold">合計（税込）</div>
              <div
                class="ml-auto text-2xl px-2 font-semibold"
                style="color: #344464"
              >
                {{
                  amountFormatter(
                    estimate.est_contents[estIndex].total_with_tax
                  )
                }}
                <span class="ml-1 text-xs">円</span>
              </div>
            </div>
          </div>
          <div class="mt-8" v-if="estimate.message">
            <div class="font-semibold leading-4 text-gray-92 mb-2">
              企業へのメッセージ
            </div>
            <div class="leading-5 text-gray-92" style="font-size: 0.8125rem">
              {{ estimate.message }}
            </div>
          </div>
          <div
            class="my-6 flex flex-col"
            v-if="estimate.est_contents[estIndex]"
          >
            <div class="flex ml-auto text-xs text-gray-62">
              ※一括見積もりの概算であり、金額を確定するものではありません。
            </div>
            <router-link
              v-if="
                estimate.is_published &&
                estimate.est_contents[estIndex].type == 'normal'
              "
              tag="button"
              :to="{
                name: 'EstimateInput',
                params: { transactionId: id, patternNumber: patternNumber },
              }"
              class="flex justify-center items-center text-gray-62 w-56 border text-sm py-2 px-8 rounded font-semibold hover:button"
            >
              <div>提出した内容を修正する</div>
            </router-link>
          </div>
        </section>
      </div>
    </template>

    <template v-else-if="estimateState == 3">
      <div>
        <div class="mb-6">
          <div>
            <h2
              v-if="txType == 'tx'"
              class="text-2xl font-semibold navy leading-8"
            >
              見積もり
            </h2>
            <h2 v-else class="text-2xl font-semibold navy leading-8">
              募集回答
            </h2>
          </div>
        </div>

        <section
          class="p-8 mb-20 bg-white rounded-lg"
          style="min-width: 666px; max-width: 986px"
        >
          <h3
            v-if="txType == 'tx'"
            class="text-xl text-gray-92 mb-6 font-semibold"
          >
            見積もりを辞退しました
          </h3>
          <h3 v-else class="text-xl text-gray-92 mb-6 font-semibold">
            募集を辞退しました
          </h3>
          <div>
            <div>
              <div v-for="item in refusedItems" :key="item.id">
                <div
                  class="border-b border-gray-12 mb-8"
                  v-if="itemString(item)"
                >
                  <div
                    class="text-gray-62 font-semibold"
                    style="font-size: 0.8125rem"
                  >
                    {{ item.name }}
                  </div>
                  <div class="text-gray-92 py-3">
                    <span
                      v-if="
                        item.input_type === 'checkbox' ||
                        item.input_type === 'select' ||
                        item.input_type === 'radio'
                      "
                      class="p-1 px-4 bg-slate-100 font-semibold rounded-full"
                      >{{ itemString(item) }}</span
                    >
                    <span v-else class="text-gray-92">{{
                      itemString(item)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>

    <template v-else-if="estimateState == 4">
      <div>
        <div class="mb-6">
          <div>
            <h2 class="text-2xl font-semibold navy leading-8">募集回答</h2>
          </div>
        </div>

        <section
          class="p-8 mb-20 bg-white rounded-lg"
          style="min-width: 666px; max-width: 986px"
        >
          <h3 class="text-xl text-gray-92 mb-6 font-semibold">
            対応を希望しました
          </h3>
          <div>
            <div>
              <div class="border-b border-gray-12 mb-8">
                <div
                  class="text-gray-62 font-semibold"
                  style="font-size: 0.8125rem"
                >
                  マッチ理由
                </div>
                <div class="text-gray-92 py-3 whitespace-pre-wrap">
                  <span>{{ answeredContent.prContent }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import { reactive, computed, toRefs, onBeforeMount, inject } from 'vue';
import { useRouter } from 'vue-router';
import { amountFormatter } from '@/utils/filters.js';
import axios from '@/utils/axiosAuth.js';

export default {
  props: {
    id: {
      type: [String, Number],
    },
    selectId: {
      type: [String, Number],
    },
    patternNumber: {
      type: Number,
    },
  },
  components: {},
  setup(props) {
    const router = useRouter();
    const globalMethods = inject('globalMethods');
    const state = reactive({
      estimate: {
        est_contents: [
          {
            total: 0,
            tax: 0,
            total_with_tax: 0,
          },
        ],
      },
      txType: props.id ? 'tx' : 'tx-select',
      refusedItems: [],
      answeredContent: {
        prContent: '',
      },
      // 2:作成済、3:辞退、4:募集回答済 // 削除 1:未作成、
      estimateState: null,
      onScroll: false,
      estIndex: computed(() => {
        if (state.estimate.est_contents) {
          return state.estimate.est_contents.findIndex(
            (i) => i.pattern_number == props.patternNumber
          );
        }
        return -1;
      }),
      prevPatternNumber: computed(() => {
        if (props.patternNumber == 1) {
          return state.estimate.est_contents.length;
        }
        return props.patternNumber - 1;
      }),
      nextPatternNumber: computed(() => {
        if (props.patternNumber == state.estimate.est_contents.length) {
          return 1;
        }
        return Number(props.patternNumber) + 1;
      }),
    });
    onBeforeMount(async () => {
      if (state.txType == 'tx') {
        await axios
          .get(`/transactions/${props.id}/est`)
          .then((response) => {
            if (
              !response.data.data.is_published &&
              !response.data.data.is_refused
            ) {
              router.push({
                name: 'EstimateInput',
                params: { transactionId: props.id },
              });
            } else if (response.data.data.is_refused) {
              state.estimateState = 3;
              state.refusedItems = response.data.data.refused_items;
            } else {
              state.estimateState = 2;
              state.estimate = response.data.data;
            }
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      } else {
        await axios
          .get(`/transaction-selects/${props.selectId}/response`)
          .then((response) => {
            if (response.data.data.is_refused) {
              state.estimateState = 3;
              state.refusedItems = response.data.data.refused_items;
            } else if (response.data.data.is_answered) {
              state.estimateState = 4;
              state.answeredContent.prContent = response.data.data.pr_content;
            }
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      }
    });
    const itemString = (data) => {
      let str = '';
      if (
        data.input_type === 'text' ||
        data.input_type === 'textarea' ||
        data.input_type === 'date'
      ) {
        str = data.values[0];
      } else if (data.input_type === 'checkbox') {
        const selected = data.options.filter(
          (option) =>
            data.values.findIndex((id) => {
              return id == option.id;
            }) >= 0
        );
        str = selected.map((e) => e.name).join('、');
      } else if (data.input_type === 'select' || data.input_type === 'radio') {
        const selected = data.options.find(
          (option) => option.id == data.values[0]
        );
        if (selected) {
          str = selected.name;
        }
      }
      return str;
    };

    window.addEventListener('scroll', function () {
      if (window.scrollY >= 580) {
        state.onScroll = true;
      } else if (window.scrollY < 580) {
        state.onScroll = false;
      }
    });

    return {
      ...toRefs(state),
      amountFormatter,
      itemString,
    };
  },
};
</script>
<style lang="scss" scoped>
.is_sticky {
  position: sticky;
  top: 110px;
  box-sizing: border-box;
  @apply text-gray-62 border-gray-12;
  background: #f1f2f6;
}
</style>
